/* RESPONSIBLE TEAM: team-standalone */

import { default as OriginalRoute } from 'embercom/routes/apps/app/automation/fin-ai-agent/custom-answers/answer/show/conversations';

export default class Route extends OriginalRoute {
  templateName = 'apps/app/automation/fin-ai-agent/custom-answers/answer/show/conversations';
  controllerName = 'apps/app/automation/fin-ai-agent/custom-answers/answer/show/conversations';
}
